import React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';

const FeedDropDown = ({ id, dropPost }) => {
  const { role } = useSelector(state => state.auth.user);

  return role==='manager'&&
  <UncontrolledDropdown>
    <DropdownToggle color="Secondary" size="sm" className="p-0">
      <FontAwesomeIcon icon="ellipsis-h" />
    </DropdownToggle>
    <DropdownMenu right>
      <DropdownItem className="text-danger" onClick={() => dropPost(id)} >Banear publicación</DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
}

export default FeedDropDown;